/* ==========================================================
   FLOATING COLLECTION V2
   Trackpad / Wheel Glide Engine
========================================================== */

document.addEventListener("DOMContentLoaded", () => {

  const wrapper = document.querySelector(
    ".floating-collection__wrapper"
  );

  if (!wrapper) return;
 


  /* ----------------------------------------
   Columns
---------------------------------------- */

const columns = document.querySelectorAll(
  ".floating-collection__column"
);


  /* ----------------------------------------
     Movement values
  ---------------------------------------- */

  let currentY = 0;
let targetY = 0;



  const easing = 0.06;
const speed = 0.55;


  /* ----------------------------------------
     Trackpad / mouse wheel
  ---------------------------------------- */

window.addEventListener(
  "wheel",
  (event) => {
        const scrollingUp = event.deltaY < 0;


   if (scrollingUp && window.scrollY > window.innerHeight * 0.9) {

      return;

    }
    
    const maxScroll = getMaxScroll();

 const heroActive =
  window.scrollY < 10;

    const atTop =
      targetY >= 0 && event.deltaY < 0;


    const atBottom =
      targetY <= -maxScroll && event.deltaY > 0;


    // allow normal page scroll after gallery
    if (!heroActive || atBottom) {

  return;

}


    // reset when returning upward
    if (atTop) {

       targetY = 0;

      return;

    }


    event.preventDefault();

    targetY -= event.deltaY * speed;

  },
  { passive:false }
);


/* ----------------------------------------
   Gallery limits
---------------------------------------- */

function getMaxScroll() {

  const hero =
    document.querySelector(".shopify-section:first-child");


  const heroHeight =
    hero ? hero.offsetHeight : window.innerHeight;


  const tallestColumn =
    Math.max(
      ...Array.from(columns).map(
        column => column.scrollHeight
      )
    );


  const galleryEndPosition = 650;

  return Math.max(
    tallestColumn - heroHeight + galleryEndPosition,
    0
  );

}

function limitGallery() {

  const maxScroll = getMaxScroll();


  if (targetY > 0) {

    targetY = 0;

  }


  if (targetY < -maxScroll) {

    targetY = -maxScroll;

  }

}
 

  /* ----------------------------------------
     Animation
  ---------------------------------------- */

  function animate() {

    currentY +=
      (targetY - currentY) * easing;


limitGallery();

console.log(currentY);

    wrapper.style.transform =
      `translate3d(0, ${currentY}px, 0)`;

 document.querySelectorAll(".floating-collection__product").forEach((card) => {

  const rect = card.getBoundingClientRect();
  const cardCenter = rect.top + rect.height / 2;

  const fadeStart = window.innerHeight * 0.22;
  const fadeEnd = window.innerHeight * 0.08;
  let opacity = 1;

  if (rect.top < fadeStart) {

    opacity =
      (rect.top - fadeEnd) /
      (fadeStart - fadeEnd);

    opacity =
      Math.max(0, Math.min(1, opacity));

    // Ease-out curve
    opacity = Math.pow(opacity, 2);

  }
// Disable pointer events once a card has fully faded out,
// allowing the header and navigation underneath to remain clickable.

  card.style.opacity = opacity;

if (opacity <= 0.01) {
    card.style.pointerEvents = "none";
} else {
    card.style.pointerEvents = "auto";
}

});
    requestAnimationFrame(animate);

  }


  animate();
  
/* ----------------------------------------
   Product expansion
---------------------------------------- */

const cards = document.querySelectorAll(
  ".floating-collection__product"
);
const floatingCollection = document.querySelector(
  ".floating-collection"
);

const expand = document.querySelector(
  ".floating-collection__expand"
);


const expandImage = document.querySelector(
  ".floating-collection__expand-img"
);

const expandTitle = document.querySelector(
  ".floating-collection__expand-title"
);

const expandPrice = document.querySelector(
  ".floating-collection__expand-price"
);

const expandLink = document.querySelector(
  ".floating-collection__expand-link"
);

const expandClose = document.querySelector(
  ".floating-collection__expand-close"
);

const addCartButton = document.querySelector(
  ".floating-collection__add-cart"
);

const variantBox = document.querySelector(
  ".floating-collection__variants"
);

let currentVariantId = null;



cards.forEach((card) => {

card.addEventListener("click", (event) => {
  

  if (
    event.target.closest(".header") ||
    event.target.closest("#shopify-section-header")
  ) {
    return;
  }


    expandImage.src =
      card.dataset.productImage;
      const productImages =
  JSON.parse(card.dataset.productImages || "[]");

const thumbnailBox =
  document.querySelector(".floating-collection__thumbnails");

if (thumbnailBox) {

  thumbnailBox.innerHTML = "";

  productImages.forEach((image) => {

    const thumb =
      document.createElement("button");

    thumb.className =
      "floating-collection__thumbnail";

    thumb.innerHTML =
      `<img src="${image}" alt="">`;

    thumb.addEventListener("click", (event) => {

      event.stopPropagation();

      expandImage.src = image;

    });

    thumbnailBox.appendChild(thumb);

  });

}


    expandTitle.textContent =
      card.dataset.productTitle;


    expandPrice.textContent =
      card.dataset.productPrice;


    expandLink.href =
      card.dataset.productUrl;

      currentVariantId =
  card.dataset.variantId;

  console.log("CARD VARIANT ID:", card.dataset.variantId);
console.log("CARD VARIANTS RAW:", card.dataset.variants);

  variantBox.innerHTML = "";


const variants =
  JSON.parse(card.dataset.variants || "[]");
  console.log("VARIANTS:", variants);


if (variants.length > 1) {


let sizeOption = null;
let stoneOption = null;


const option1Values =
  variants.map(
    variant => variant.option1
  );


const option2Values =
  variants.map(
    variant => variant.option2
  );


if (
  option1Values.every(
    value => !isNaN(value)
  )
) {

  sizeOption = 1;

} else {

  stoneOption = 1;

}


if (
  option2Values.some(
    value => value
  )
) {

  stoneOption = 2;

}


const sizes =
  sizeOption
    ? [
        ...new Set(
          variants.map(
            variant =>
              variant["option" + sizeOption]
          )
        )
      ]
    : [];


const stones =
  stoneOption
    ? [
        ...new Set(
          variants
            .map(
              variant =>
                variant["option" + stoneOption]
            )
            .filter(stone => stone)
        )
      ]
    : [];


let selectedSize = null;
let selectedStone = null;


variantBox.innerHTML = "";

if (sizes.length > 0) {

variantBox.innerHTML +=
  "<div class='variant-label'>SIZE</div><div class='size-group'></div>";


  sizes.forEach(size => {


    const button =
      document.createElement("button");


    button.textContent = size;


    button.className =
      "floating-collection__variant-button";


   button.addEventListener("click", (event) => {


  event.stopPropagation();


  selectedSize = size;


variantBox
  .querySelectorAll(".size-group .floating-collection__variant-button")
  .forEach(btn =>
    btn.classList.remove("is-selected")
  );


button.classList.add("is-selected");

  updateVariant();


});

variantBox
  .querySelector(".size-group")
  .appendChild(button);

});

}


if (stones.length > 0) {

variantBox.insertAdjacentHTML(
  "beforeend",
  "<div class='variant-label'>STONE</div><div class='stone-group'></div>"
);


  stones.forEach(stone => {


    const button =
      document.createElement("button");


    button.textContent = stone;


    button.className =
      "floating-collection__variant-button";


    button.addEventListener("click", (event) => {


  event.stopPropagation();


  selectedStone = stone;


variantBox
  .querySelectorAll(".stone-group .floating-collection__variant-button")
  .forEach(btn =>
    btn.classList.remove("is-selected")
  );


button.classList.add("is-selected");


  updateVariant();


});

variantBox
  .querySelector(".stone-group")
  .appendChild(button);

});

}


  function updateVariant() {


    const selected =
      variants.find(
        variant =>
          variant.option1 === selectedSize &&
          variant.option2 === selectedStone
      );


    if (selected) {
      currentVariantId = selected.id;
    }


  }


}


    expand.classList.add("is-active");
    floatingCollection.classList.add("is-expanded");


  });

});



expandClose.addEventListener("click", () => {

  expand.classList.remove("is-active");
  floatingCollection.classList.remove("is-expanded");

});

/* ----------------------------------------
   Add to Cart
---------------------------------------- */

addCartButton.addEventListener("click", (event) => {

  event.stopPropagation();

    console.log("ADD CLICKED", currentVariantId);


  if (!currentVariantId) return;


fetch("/cart/add.js", {
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  },

  body: JSON.stringify({
    id: currentVariantId,
    quantity: 1,
    sections: [
      "cart-drawer",
      "cart-icon-bubble"
    ]
  })
})


.then(response =>
  response.json()
)


.then(response => {


  const cartDrawer =
    document.querySelector(
      "cart-drawer"
    );


  if (cartDrawer) {

cartDrawer.getSectionsToRender().forEach((section) => {

  const sectionElement =
    section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);


  if (sectionElement) {

    sectionElement.innerHTML =
      cartDrawer.getSectionInnerHTML(
        response.sections[section.id],
        section.selector
      );

  }

});

  }


  addCartButton.textContent =
    "Added";


  setTimeout(() => {

    addCartButton.textContent =
      "Add to Cart";

  }, 2000);


});


});
});
 
// Thumbnail drag scroll
const thumbnailRows = document.querySelectorAll(
  ".floating-collection__thumbnails"
);

thumbnailRows.forEach((row) => {
  let isDown = false;
  let startX;
  let scrollLeft;

  row.addEventListener("mousedown", (e) => {
    isDown = true;
    row.classList.add("dragging");
    startX = e.pageX - row.offsetLeft;
    scrollLeft = row.scrollLeft;
  });

  row.addEventListener("mouseleave", () => {
    isDown = false;
    row.classList.remove("dragging");
  });

  row.addEventListener("mouseup", () => {
    isDown = false;
    row.classList.remove("dragging");
  });

  row.addEventListener("mousemove", (e) => {
    if (!isDown) return;

    e.preventDefault();
    e.stopPropagation();

    const x = e.pageX - row.offsetLeft;
    const walk = (x - startX) * 1.5;

    row.scrollLeft = scrollLeft - walk;
  });
});
// Trackpad / mouse wheel thumbnail scroll
document.addEventListener(
  "wheel",
  (event) => {

    const row = event.target.closest(
      ".floating-collection__thumbnails"
    );

    if (!row) return;

    event.preventDefault();
    event.stopPropagation();

    row.scrollLeft +=
      event.deltaY + event.deltaX;

  },
  { passive: false }
);

// Thumbnail drag movement
document.addEventListener("mousedown", (event) => {
  const row = event.target.closest(
    ".floating-collection__thumbnails"
  );

  if (!row) return;

  let startX = event.pageX;
  let startScroll = row.scrollLeft;

  function move(e) {
    e.preventDefault();

    const distance =
      e.pageX - startX;

    row.scrollLeft =
      startScroll - distance;
  }

  function stop() {
    document.removeEventListener(
      "mousemove",
      move
    );

    document.removeEventListener(
      "mouseup",
      stop
    );
  }

  document.addEventListener(
    "mousemove",
    move
  );

  document.addEventListener(
    "mouseup",
    stop
  );
});